//components
import { PillLink } from '@/containers-ai/Buttons';

//styles
import {
  EndCTASection,
  Wrap,
  Title,
  TitleHighlight,
  Copy,
} from './EndCTA.styles';

export function EndCTA({ variant = 'top' }) {
  return (
    <EndCTASection
      id={variant === 'top' ? 'cta' : undefined}
      $variant={variant}
    >
      <Wrap>
        <Title>
          Tell us the workflow that bothers you most.{' '}
          <TitleHighlight>We&rsquo;ll run it.</TitleHighlight>
        </Title>
        <Copy>
          The AI runs it, our operators back it, and you see the outcome in
          your own systems.
        </Copy>
        <PillLink
          href="#top"
          style={{ fontSize: '16px', padding: '16px 32px' }}
        >
          Book a working session &#8594;
        </PillLink>
      </Wrap>
    </EndCTASection>
  );
}
